import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import "vuetify/dist/vuetify.min.css";
import "@/assets/scss/main.scss";
import "@/components/global";
import "@/utils/validators";
import "@/utils/filters";
import "@/router/guards";
import { status , lookupTypes } from "./utils/common";
import { hasPermission } from "./utils/helpers";
import * as settingPermissions from "./permissions/settingPermissions";
import * as patientsManagementPermissions from "./permissions/patientsManagementPermissions";
import * as inventoryManagementPermissions from "./permissions/inventoryManagementPermissions";

Vue.config.productionTip = false
Vue.prototype.$status = status;
Vue.prototype.$lookupTypes = lookupTypes;
Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$settingPermissions = settingPermissions;
Vue.prototype.$patientsManagementPermissions = patientsManagementPermissions;
Vue.prototype.$inventoryManagementPermissions = inventoryManagementPermissions;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
